
import { supabase } from "./client";
import { Bank } from "@/types/models";

export const getBanks = async (): Promise<Bank[]> => {
  const { data, error } = await supabase
    .from('bank')
    .select('*')
    .eq('active', true)
    .order('name');

  if (error) {
    throw error;
  }

  return data || [];
};
